import React from 'react';

function ChatBubble({ sender, text, buttons, onButtonClick, vertical }) {
  return (
    <div className={`chat-bubble ${sender}`}> 
      <div className="chat-avatar">{sender === 'bot' ? '🤖' : '🧑'}</div>
      <div className="chat-content">
        <div className="chat-text">{text}</div>
        {buttons && (
          <div className={`chat-buttons${vertical ? ' vertical' : ''}`}>
            {buttons.map((btn, i) => (
              <button
                key={i}
                className="chat-select-btn"
                onClick={() => onButtonClick(btn.value)}
              >{btn.label}</button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatBubble; 